var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"popupComponent":_vm.popupComponent,"show-add-button":false,"title":"Mail Template List","icon":"mdi-grid","stateendpoint":"mailTemplate.mailTemplates","show-default-action-buttons":false,"actions":_vm.actions,"action-buttons":_vm.actionButton}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }